







/// <summary>
/// This object provides js functions for a comparison list as html table <br/>
/// <br/>
/// Author: AFU<br />
/// Date: 14.5.2025<br />
/// Copyright ©: EUDT GmbH 2025 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 14.5.2025                                             *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>


jQuery.widget("bluaul.ComparisonList", jQuery.common.vcBaseV4, {
    colorDecrease: "#e6a9a9",
    colorIncrease: "#c3e8a5",
    maxEntries: 10,
    singleColWidth:146,
    columnStyleClass: "vc-grid-1col",
    type: "",
    _create: function () {
        this._createVisual(391);
        this._super();
    },
    _initHTML: function () {
        var me = this;
        try {
            me._setRoot(".comparison-list");
            me._buildHtml();
           
        } catch (e) { me._writeErr(e); return false;}
        return true;
    },

    _initEvents: function () {
        var me = this;
        try {
            me._initStructure();
            me._fetch();
        } catch (e) { me._writeErr(e);return false; }
        return true;
    },

    _buildHtml: function () {
        /// <summary>
        /// This function builds the html structure only
        /// </summary>
        var me = this;
        try {
            me.myHtml = { menu: {},   list: {} };

            //menu
            obj = me.myHtml.menu;
            obj.wrapper = me._setObj("", "vc-grid-margin-bottom");
            me._setLoadingIcon(obj.wrapper);

            //entry list
            obj = me.myHtml.list;
            obj.wrapper = me._setObj("", "vc-list");
            obj.header = me._setListHeader("");
            obj.wrapper.append(obj.header);

            obj.entries = [];
            //we init a punch of entry divs
            for (var i = 0; i < me.maxEntries; i++) {
                var entry = me._setObj("entries" + i, "entries vc-list-table").css("max-height", "none").hide();
                obj.entries.push(entry);
                obj.wrapper.append(entry);
            }
            obj.entries[0].show();

            me.myRoot.append(me.myHtml.menu.wrapper, me.myHtml.list.wrapper);
        

        } catch (e) {me._writeErr(e);return false;}
        return true;
    },


    _buildMenu: function () {
        /// <summary>
        /// This function builds the sub menu with years and comparisons
        /// </summary>
        var me = this;
        try {

            let obj = me.myHtml.menu;
            obj.wrapper.html("");
            obj.btnYears = [];
            obj.btnComparison = [];

            let index = 0;

            var currentYear = moment(me.settings.parameter.EndDate, "DD.MM.YYYY HH:mm:ss").year();

            if (me.settings.parameter.Type == "MULTI") {
                //generate the button for each year
                for (var i = 0; i < me.settings.parameter.Years; i++) {
                    var btn = me._setObj("", "div-sub-menu button-toggle vc-grid-1col button-toggle").data("index", index).html(currentYear - i);
                    btn.button();
                    obj.btnYears.push(btn);
                    obj.wrapper.append(btn);
                    index++;
                }
                obj.btnYears[0].addClass("button-toggle-active");

                //generate the button for each comparison
                for (var i = 1; i < me.settings.parameter.Years; i++) {
                    var btn = me._setObj("", "div-sub-menu button-toggle vc-grid-1col button-toggle").data("index", index).html((currentYear) + "/" + (currentYear - i));
                    btn.button();
                    obj.btnYears.push(btn);
                    obj.wrapper.append(btn);
                    index++;
                }
            }
          
        } catch (e) { me._writeErr(e); return false; }
        return true;
    },


    _initStructure: function () {
        /// <summary>
        /// This function inits various events and handlers
        /// </summary>
        var me = this;
        try {


            ////// menu button click handler
            me.myHtml.menu.wrapper.off("click", ".div-sub-menu").on("click",".div-sub-menu",  function (e) {
                //toggle the menu button
                me.myHtml.menu.wrapper.find(".div-sub-menu").removeClass("button-toggle-active");
                $(e.currentTarget).addClass("button-toggle-active");
                //toggle the entry div
                me.myHtml.list.wrapper.find(".entries").hide();
                var index = parseInt($(e.currentTarget).data("index"));
                $(me.myHtml.list.wrapper.find(".entries")[index]).show();

            });

            //click handler for selected rows
            me.myHtml.list.wrapper.off("click", ".row").on("click", ".row", function (e) { me._toggleSelectedRow($(e.currentTarget)); });
          
        } catch (e) { me._writeErr(e); }
    },


    _toggleSelectedRow: function (obj) {
        /// <summary>
        /// This function marks a selected row in each entry div
        /// </summary>
        var me = this;
        try {
            me.myHtml.list.wrapper.find(".row.selected").removeClass("selected");

            var index = parseInt(obj.data("index"));
            for (var i = 0; i < me.maxEntries; i++) {
                $(me.myHtml.list.entries[i].find(".row")[index]).addClass("selected");
            }
           
            obj.addClass("selected");
        } catch (e) { me._writeErr(e); } ;
    },

    _fetch: function () {
        /// <summary>
        /// This function fetches the data based on the current settings
        /// </summary>
        var me = this;
        try {
            me.myHtml.menu.wrapper.show();
            me._setLoadingIcon(me.myHtml.menu.wrapper);
            me.myHtml.list.wrapper.hide();

            me.getData({ }, function (result) {

                //check response content
                if (result == null) { me.showMessage(me.resources.err_loadData, true); return true; }
                me.myData = result;

                //let's see if we find any valid data entries
                var dataFound = null;
                $.each(me.myData, function (e, obj) {
                    if (obj != null) { dataFound = obj; return; }
                }); 
                if (dataFound == null) {
                    me.myHtml.menu.wrapper.hide();
                    me.myHtml.list.wrapper.hide();
                    me.showMessage(me.resources.noEntriesExist, false);
                    return true;
                }

                //build up the new menu
                me._buildMenu();
                me.myHtml.menu.wrapper.show();
                me.myHtml.list.wrapper.show();

                //we need column sizes, widths and heights
                me._setHeightsAndWidths(dataFound.Captions.length);
            
                //we use the first valid data for creating the signal list
                if (me.settings.parameter.Type == "MULTI") me._generateHeader(dataFound);
                if (me.settings.parameter.Type == "SINGLE") me._generateHeaderForSingle(dataFound);

                //fill all entry divs
                var index = 0;
                for (var i = 0; i < me.settings.parameter.Years; i++) {
                    me._generateList(me.myHtml.list.entries[index], me.myData[index]);
                    index++;
                }
                for (var i = 0; i < me.settings.parameter.Years -1; i++) {
                   
                    me._generateList(me.myHtml.list.entries[index], me.myData[index]);
                    index++;
                }

                // after loading the data we need to format the header for single type
                if (me.settings.parameter.Type == "SINGLE") me._formatSingleHeader();

            });
        } catch (e) { me._writeErr(e); return false; }return true;
    },



    _generateHeader: function (data) {
        /// <summary>
        /// This function generates the header list
        /// </summary>
        var me = this;
        try {

            me.myHtml.list.header.html("");

            var line = me._setListItem();
            line.column.append(me._setListElement("", "vc-grid-1col").html("<br/>"));
            var name = "";
            var count = 0;
            $.each(data.Captions, function (e, obj) {
                if (me.settings.parameter.Type == "MULTI") {
                    var signal = me._setListElement("", me.columnStyleClass + " center").html(obj.Name + " [" + obj.Unit + "]");
                    if (obj.IsSumSignal) { signal.css("text-decoration", "underline"); };
                    line.column.append(signal);
                } else {


                    var current = obj.Name + " [" + obj.Unit + "]<br/>" + obj.SignalGroup;
                    if (name == "") { name = current;  }

                    if (name != current) {
                        var signal = me._setListElement("", " center").width((me.singleColWidth-2) * count).html(name );
                        if (obj.IsSumSignal) { signal.css("text-decoration", "underline"); };
                        line.column.append(signal);
                        name = current;
                        count = 1;
                    } else {
                        count++;
                    }
                }


            });
            if (me.settings.parameter.Type == "SINGLE") {
                if (count > 0 && name != "") {
                    var signal = me._setListElement("", " center").width(me.singleColWidth * count).html(name);
                    if (obj.IsSumSignal) { signal.css("text-decoration", "underline"); };
                    line.column.append(signal);
                }
            }
            me.myHtml.list.header.append(line.item);

            //add another line for the signal groups
            line = me._setListItem();
            line.column.append(me._setListElement("", "vc-grid-1col").html(me.specific.resources.date));
            $.each(data.Captions, function (e, obj) {
                line.column.append(me._setListElement("", me.columnStyleClass + " center").html(me.settings.parameter.Type == "MULTI" ? obj.SignalGroup : obj.Period));
            });
            me.myHtml.list.header.append(line.item);
         

            return true;
        } catch (e) { me._writeErr(e); return false; }
    },


    _generateHeaderForSingle: function (data) {
        /// <summary>
        /// This function generates the header list for single type only
        /// </summary>
        var me = this;
        try {
            me.myHtml.list.header.html("");

            // we create period groups for the top header row (e.g. 2025, 2024, 2023)
            var groups = [];
            var norm = function (p) { return (p == null ? "" : ("" + p).trim()); };

            var current = null;
            var count = 0;
            for (var i = 0; i < data.Captions.length; i++) {
                var p = norm(data.Captions[i].Period);
                if (current === null) { current = p; count = 1; }
                else if (p === current) { count++; }
                else { groups.push({ period: current, count: count }); current = p; count = 1; }
            }
            if (current !== null) groups.push({ period: current, count: count });

            me.periodGroups = groups;

            // first row: place holder + periods (centered over the respective columns) - e.g. 2025, 2024, 2023
            var line1 = me._setListItem();
            line1.column.append(me._setListElement("", "vc-grid-1col").html("&nbsp;")); // placeholder for date column, because we have no date info in first row
            for (var i = 0; i < groups.length; i++) {
                var period = me._setListElement("", me.columnStyleClass + " center group-period").html(groups[i].period);
                period.css("font-weight", "600");
                line1.column.append(period);
            }
            me.myHtml.list.header.append(line1.item);

            // second row: date + caption names of signals + units
            var line2 = me._setListItem();
            line2.column.append(me._setListElement("", "vc-grid-1col strong date-head").html(me.specific.resources.date));

            for (var j = 0; j < data.Captions.length; j++) {
                var capt = data.Captions[j];
                var label = capt.Name + (capt.Unit ? " [" + capt.Unit + "]" : "");
                var cell = me._setListElement("", me.columnStyleClass + " center"); //.html(label);
                var title = $("<div>").addClass("cap-title").text(label);
                var group = $("<div>").addClass("cap-group").text(capt.SignalGroup || "");
                cell.append(title, group);

                if (capt.IsSumSignal) cell.css("text-decoration", "underline");
                
                line2.column.append(cell);
            }
            me.myHtml.list.header.append(line2.item);

            // we calculate and set the widths of header columns after loading the list data
            return true;
        } catch (e) { me._writeErr(e); return false; }
    },


    _formatSingleHeader: function () {
        /// <summary>
        /// This function formats the header for single type only - it needs to be called after the list data has been loaded
        /// </summary>
        var me = this;
        try {
            var header = me.myHtml.list.header;
            var rows = header.find(".vc-list-item");
            if (rows.length < 2) return;

            var top = rows.eq(0);    // title of periods
            var bottom = rows.eq(1);    // date + caption names

            // header cells
            var dateHead = bottom.find(".vc-grid-1col").first();
            var nameHeads = bottom.find("." + me.columnStyleClass);
            if (!nameHeads.length) return;

            // we get the first visible entry with data rows
            var entry = null;
            for (var i = 0; i < me.maxEntries; i++) {
                var t = $(me.myHtml.list.entries[i]);
                if (t.is(":visible") && t.find(".row").length) { entry = t; break; }
                if (!entry && t.find(".row").length) entry = t;
            }
            if (!entry) return;

            // we get the first data row
            var firstRow = entry.find(".row").first();
            if (!firstRow.length) return;

            // we calculate and set the widths of header columns
            var dateCell = firstRow.find(".vc-grid-1col").first();
            var dateOuter = dateCell.outerWidth(true);
            var dateHeadDelta = dateHead.outerWidth(true) - dateHead.width();
            dateHead.width(Math.max(0, dateOuter - dateHeadDelta));

            // we calculate and set the widths of caption name columns
            var valCells = firstRow.find("." + me.columnStyleClass);
            nameHeads.each(function (idx) {
                var h = $(this);
                var d = valCells.eq(idx);
                if (!d.length) return;
                var wOuter = d.outerWidth(true);
                var delta = h.outerWidth(true) - h.width();
                h.width(Math.max(0, wOuter - delta));
            });

            // set the period title centered over the respective caption name columns
            var periodCells = top.find(".group-period");
            if (periodCells.length) {
                var run = 0;
                for (var gi = 0; gi < me.periodGroups.length; gi++) {
                    var count = me.periodGroups[gi].count;
                    var sumOuter = 0;
                    for (var k = 0; k < count; k++) {
                        var nh = nameHeads.eq(run + k);
                        if (nh.length) sumOuter += nh.outerWidth(true);
                    }
                    var p = periodCells.eq(gi);
                    var pDelta = p.outerWidth(true) - p.width();
                    p.width(Math.max(0, sumOuter - pDelta));
                    run += count;
                }
            }

            // we add vertical separator lines between the period groups
            header.css("position", "relative").find(".period-sep").remove();
            var headerLeft = header.offset().left;
            var headerHeight = header.outerHeight();

            // first line is placed on the left side of the first period group
            var positions = [];
            var startIdx = 1;
            for (var gi = 0; gi < me.periodGroups.length; gi++) {
                var startCell = nameHeads.eq(startIdx);
                if (startCell.length) positions.push(Math.round(startCell.offset().left - headerLeft));
                startIdx += me.periodGroups[gi].count;
            }

            // last line is placed on the right side of the last period group
            var lastIdx = nameHeads.length - 1;
            if (lastIdx >= 0) {
                var last = nameHeads.eq(lastIdx);
                positions.push(Math.round(last.offset().left - headerLeft + last.outerWidth(true)));
            }

            var sepColor = "#fff"; 
            positions.forEach(function (x) {
                $("<div/>").addClass("period-sep").css({
                    position: "absolute",
                    top: 0,
                    left: x + "px",
                    width: "1px",
                    height: headerHeight + "px",
                    background: sepColor,
                    pointerEvents: "none",
                    zIndex: 2
                }).appendTo(header);
            });

        } catch (e) { me._writeErr(e); }
    },


    _generateList: function (entries, data) {
        /// <summary>
        /// This function generates the table and fills the list with data
        /// </summary>
        var me = this;
        try {

            if (data == null) {
                entries.html($("<br>")).append($("<div>").addClass("note").html(me.resources.noEntriesExist));
                return false;
            }
            //clear list
            entries.html("");
       
            if (!me._fillRows(entries, data)) { 
                entries.html($("<br>")).append($("<div>").addClass("note").html(me.resources.noEntriesExist));
                return false;
            }

            ////we use no filter - so we set everything to found
            entries.find(".vc-list-item").addClass("found");
            me._setAltListStyle(entries);

            //we add the unit for sum row
            me._generateUnitRow(entries, data, data.Sum, "<br/>", false);

            //we add the sum row
            me._generateSumRow(entries,data, data.Sum, me.specific.resources.sum, true);

            //we add the sum row for percents
            me._generateSumRow(entries, data, data.SumInPercent, "in %", false);

            //we add the unit for price row
            me._generateUnitRow(entries, data, data.Sum, "<br/>", true);

            //we add the sum row in prices
            me._generateSumRow(entries, data, data.SumPrice, me.specific.resources.price, false);

            return true;
        } catch (e) {me._writeErr(e);return false;}
    },


    _fillRows: function (entries, data) {
        /// <summary>
        /// This function generates all data rows
        /// </summary>
        var me = this;
        var bFound = false;
        try {

            var index = 0;
            var col = 0;
            $.each(data.Rows, function (e, entry) {

              
                bFound = true;
                var line = me._setListItem();
                line.item.addClass("row").data("index", index);
                index++;
                //first, write the date
                line.column.append(me._setListElement("", "vc-grid-1col").html(entry.Date));

                colIndex = 0;
                //now, write all data columns
                $.each(entry.Columns, function (e, col) {
                  
                  

                    var val = (col.Value.length > 0) ? col.Value : "<br/>"; 
                    if (col.Status == 1) val += " " + me.specific.resources.IconInvalid;
                
                    var entry = me._setListElement("", me.columnStyleClass + " val").html(val);

                    if (data.Captions[colIndex].IsComparison) {
                        if (col.ValueAsDbl > 0) { entry.css("background-color", data.Captions[colIndex].SwitchChange == false ? me.colorDecrease : me.colorIncrease ); }
                        if (col.ValueAsDbl < 0) { entry.css("background-color", data.Captions[colIndex].SwitchChange == false ? me.colorIncrease : me.colorDecrease); }
                     
                    }
                    colIndex++;
                    line.column.append(entry);
                });
              
               entries.append(line.item);
            });

            return bFound;
        } catch (e) { me._writeErr(e); return false; }
    },



    _generateUnitRow: function (entries, data, sumRow, caption, showPrice) {
        /// <summary>
        /// This function generates the sum rows
        /// </summary>
        var me = this;
        try {
         

            var line = me._setListItem();
            line.column.append(me._setListElement("", "vc-grid-1col sum").html(caption));

            var colIndex = 0;
            $.each(sumRow.Columns, function (e, obj) {
              
                var unit = "";
                if (showPrice) {
                    unit = (data.Captions[colIndex].UnitPrice.length > 0) ? "[" + data.Captions[colIndex].UnitPrice + "]" : "<br/>";
                } else {
                    unit = (data.Captions[colIndex].Unit.length > 0) ? "[" + data.Captions[colIndex].Unit + "]" : "<br/>";
                }
              
                var entry = me._setListElement("", me.columnStyleClass + " sum val").html(unit);
              
                line.column.append(entry);
                colIndex++;
            });

            entries.append(line.item);

            return true;
        } catch (e) { me._writeErr(e); return false; }
    },


    _generateSumRow: function (entries, data, sumRow, caption, showChange) {
        /// <summary>
        /// This function generates the sum rows
        /// </summary>
        var me = this;
        try {

           
            var line = me._setListItem();
            line.column.append(me._setListElement("", "vc-grid-1col sum").html(caption));

            var colIndex = 0;
            $.each(sumRow.Columns, function (e, obj) {

                var val = (obj.Value.length > 0) ? obj.Value : "<br/>";
                if (obj.Status == 1) val += " " + me.specific.resources.IconInvalid;

                var entry = me._setListElement("", me.columnStyleClass + " sum val").html(val);
                if (showChange && data.Captions[colIndex].IsComparison) {
                    if (obj.ValueAsDbl > 0) { entry.css("background-color", data.Captions[colIndex].SwitchChange == false ? me.colorDecrease : me.colorIncrease); }
                    if (obj.ValueAsDbl < 0) { entry.css("background-color", data.Captions[colIndex].SwitchChange == false ? me.colorIncrease : me.colorDecrease); }
                }
                
                line.column.append(entry);


                colIndex++;
            });

            entries.append(line.item);

            return true;
        } catch (e) { me._writeErr(e); return false; }
    },

    _setHeightsAndWidths: function (iColumns) {
        /// <summary>
        /// This function calculates and sets the height of elements relatively to the general content height
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }
            var bSmallCols = false;
            var bOversize = false;

            //calculate the width of the single columns and the full with of the entries
            //we remove the first date column
            var wCol = parseInt((me.container.width - me.singleColWidth) / iColumns);

            //find out if we can only use small columns (we add same safety space)
            if (wCol < ((me.singleColWidth + 12) * 2)) {
                me.columnStyleClass = "vc-grid-1col";
                bSmallCols = true;
            } else {
                me.columnStyleClass = "vc-grid-2col";
                bSmallCols = false;
            }

            if (bSmallCols) {
                var fullWidth = me.singleColWidth + (iColumns * me.singleColWidth);
                //find out if we are larger than our visual
                bOversize = (fullWidth > me.myRoot.width());
                if (bOversize) {
                    me.myHtml.list.header.css("width", fullWidth + 5).css("font-size", "smaller");
                    for (var i = 0; i < me.maxEntries; i++) {
                        $(me.myHtml.list.entries[i]).css("width", fullWidth + 5);
                    }
                }
             
            }

            //set the height for the list and all entry divs
            let hList = me._getVisualHeight() - me.myHtml.menu.wrapper.height()- 20;
            me.myHtml.list.wrapper.css("height", hList);
            hList -= me.myHtml.list.header.outerHeight();
            //we remove some pixel for the horizontal scroll bar 
            if (bOversize) hList -= 20;
            for (var i = 0; i < me.maxEntries; i++) {
                $(me.myHtml.list.entries[i]).css("max-height", hList);
            }


          
        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    specificInfoHandling: function (bError) {
        /// <summary>
        /// This function handles error states - it hides specific objects on error message
        /// </summary>
        var me = this;
        try {
            if (bError) {
                me.myHtml.menu.wrapper.hide();
                me.myHtml.list.wrapper.hide();
            }
           
        } catch (e) { me._writeErr(e); return false;}
        return true;
    }
});
